// Generated by purs version 0.14.5
"use strict";
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Array_NonEmpty_Internal = require("../Data.Array.NonEmpty.Internal/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Variant_Internal = require("../Data.Variant.Internal/index.js");
var Kishimen = require("../Kishimen/index.js");
var TofuJSON = require("../TofuJSON/index.js");
var ColCheckbox = (function () {
    function ColCheckbox() {

    };
    ColCheckbox.value = new ColCheckbox();
    return ColCheckbox;
})();
var ColName = (function () {
    function ColName() {

    };
    ColName.value = new ColName();
    return ColName;
})();
var ColUnit = (function () {
    function ColUnit() {

    };
    ColUnit.value = new ColUnit();
    return ColUnit;
})();
var ColCostClassCode = (function () {
    function ColCostClassCode() {

    };
    ColCostClassCode.value = new ColCostClassCode();
    return ColCostClassCode;
})();
var ColPricePerUnit = (function () {
    function ColPricePerUnit() {

    };
    ColPricePerUnit.value = new ColPricePerUnit();
    return ColPricePerUnit;
})();
var ColPricePerUnitUnit = (function () {
    function ColPricePerUnitUnit() {

    };
    ColPricePerUnitUnit.value = new ColPricePerUnitUnit();
    return ColPricePerUnitUnit;
})();
var ColTotalAmountSum = (function () {
    function ColTotalAmountSum() {

    };
    ColTotalAmountSum.value = new ColTotalAmountSum();
    return ColTotalAmountSum;
})();
var ColTotalPriceSum = (function () {
    function ColTotalPriceSum() {

    };
    ColTotalPriceSum.value = new ColTotalPriceSum();
    return ColTotalPriceSum;
})();
var ColResourceClassificationGroup = (function () {
    function ColResourceClassificationGroup() {

    };
    ColResourceClassificationGroup.value = new ColResourceClassificationGroup();
    return ColResourceClassificationGroup;
})();
var ColSortingNumber = (function () {
    function ColSortingNumber() {

    };
    ColSortingNumber.value = new ColSortingNumber();
    return ColSortingNumber;
})();
var ColDiscountPercentage = (function () {
    function ColDiscountPercentage() {

    };
    ColDiscountPercentage.value = new ColDiscountPercentage();
    return ColDiscountPercentage;
})();
var ColPriceWithDiscount = (function () {
    function ColPriceWithDiscount() {

    };
    ColPriceWithDiscount.value = new ColPriceWithDiscount();
    return ColPriceWithDiscount;
})();
var ColCurrencyId = (function () {
    function ColCurrencyId() {

    };
    ColCurrencyId.value = new ColCurrencyId();
    return ColCurrencyId;
})();
var ColContract = (function () {
    function ColContract() {

    };
    ColContract.value = new ColContract();
    return ColContract;
})();
var ColIndex = (function () {
    function ColIndex() {

    };
    ColIndex.value = new ColIndex();
    return ColIndex;
})();
var ColValidDate = (function () {
    function ColValidDate() {

    };
    ColValidDate.value = new ColValidDate();
    return ColValidDate;
})();
var ColDiscountGroupCode = (function () {
    function ColDiscountGroupCode() {

    };
    ColDiscountGroupCode.value = new ColDiscountGroupCode();
    return ColDiscountGroupCode;
})();
var ColChangeDate = (function () {
    function ColChangeDate() {

    };
    ColChangeDate.value = new ColChangeDate();
    return ColChangeDate;
})();
var ColTaxRate = (function () {
    function ColTaxRate() {

    };
    ColTaxRate.value = new ColTaxRate();
    return ColTaxRate;
})();
var ColEanCode = (function () {
    function ColEanCode() {

    };
    ColEanCode.value = new ColEanCode();
    return ColEanCode;
})();
var ColPLPriceListId = (function () {
    function ColPLPriceListId() {

    };
    ColPLPriceListId.value = new ColPLPriceListId();
    return ColPLPriceListId;
})();
var ColInternalCode = (function () {
    function ColInternalCode() {

    };
    ColInternalCode.value = new ColInternalCode();
    return ColInternalCode;
})();
var ColVendor = (function () {
    function ColVendor() {

    };
    ColVendor.value = new ColVendor();
    return ColVendor;
})();
var ColVendorCode = (function () {
    function ColVendorCode() {

    };
    ColVendorCode.value = new ColVendorCode();
    return ColVendorCode;
})();
var ColVendorUnit = (function () {
    function ColVendorUnit() {

    };
    ColVendorUnit.value = new ColVendorUnit();
    return ColVendorUnit;
})();
var ColVendorBatchSize = (function () {
    function ColVendorBatchSize() {

    };
    ColVendorBatchSize.value = new ColVendorBatchSize();
    return ColVendorBatchSize;
})();
var genericEstimationResourceColumn = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return ColCheckbox.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ColName.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return ColUnit.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return ColCostClassCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return ColPricePerUnit.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return ColPricePerUnitUnit.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return ColTotalAmountSum.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return ColTotalPriceSum.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return ColResourceClassificationGroup.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return ColSortingNumber.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return ColDiscountPercentage.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return ColPriceWithDiscount.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
            return ColCurrencyId.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
            return ColContract.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
            return ColIndex.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
            return ColValidDate.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
            return ColDiscountGroupCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))) {
            return ColChangeDate.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))) {
            return ColTaxRate.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))) {
            return ColEanCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))))) {
            return ColPLPriceListId.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))))) {
            return ColInternalCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))))))) {
            return ColVendor.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))))))) {
            return ColVendorCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))))))))) {
            return ColVendorUnit.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))))))))))))))))) {
            return ColVendorBatchSize.value;
        };
        throw new Error("Failed pattern match at Types.MergedEstimationResource (line 107, column 1 - line 107, column 86): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ColCheckbox) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ColName) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ColUnit) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof ColCostClassCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof ColPricePerUnit) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof ColPricePerUnitUnit) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof ColTotalAmountSum) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof ColTotalPriceSum) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof ColResourceClassificationGroup) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
        };
        if (x instanceof ColSortingNumber) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
        };
        if (x instanceof ColDiscountPercentage) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof ColPriceWithDiscount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof ColCurrencyId) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        if (x instanceof ColContract) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))));
        };
        if (x instanceof ColIndex) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))));
        };
        if (x instanceof ColValidDate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))));
        };
        if (x instanceof ColDiscountGroupCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))));
        };
        if (x instanceof ColChangeDate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))));
        };
        if (x instanceof ColTaxRate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))));
        };
        if (x instanceof ColEanCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))));
        };
        if (x instanceof ColPLPriceListId) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))))));
        };
        if (x instanceof ColInternalCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))))));
        };
        if (x instanceof ColVendor) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))))))));
        };
        if (x instanceof ColVendorCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))))))));
        };
        if (x instanceof ColVendorUnit) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))))))))));
        };
        if (x instanceof ColVendorBatchSize) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))))))))))))))))))));
        };
        throw new Error("Failed pattern match at Types.MergedEstimationResource (line 107, column 1 - line 107, column 86): " + [ x.constructor.name ]);
    }
};
var tofuJSONEstimationResourceColumn = {
    writeImpl: (function () {
        var $367 = TofuJSON.writeImpl(TofuJSON.tofuJSONVariant()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil)))))))))))))))))))))))))))(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant))))))))))))))))))))))))))));
        var $368 = Kishimen.genericSumToVariant(genericEstimationResourceColumn)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColName";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColContract";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColIndex";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColName";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColName";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })));
        return function ($369) {
            return $367($368($369));
        };
    })(),
    readImpl: (function () {
        var $370 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Kishimen.variantToGenericSum(genericEstimationResourceColumn)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColName";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColContract";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColIndex";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColName";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        }))({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColName";
            }
        }))({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        }))));
        var $371 = TofuJSON.readImpl(TofuJSON.tofuJSONVariant()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil)))))))))))))))))))))))))))(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPricePerUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPricePerUnitUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColTotalAmountSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColTotalPriceSum";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant))))))))))))))))))))))))))));
        return function ($372) {
            return $370($371($372));
        };
    })()
};
var fromMergedEstimationResource = function (r) {
    var transform = function (v) {
        return {
            resource: v.value0,
            component: v.value1
        };
    };
    return {
        costClassCode: r.costClassCode,
        name: r.name,
        unit: r.unit,
        pricePerUnit: r.pricePerUnit,
        currencyId: r.currencyId,
        changeDate: r.changeDate,
        contract: r.contract,
        discountGroupCode: r.discountGroupCode,
        discountPercentage: r.discountPercentage,
        eanCode: r.eanCode,
        index: r.index,
        priceWithDiscount: r.priceWithDiscount,
        resourceClassificationGroup: r.resourceClassificationGroup,
        taxPercentage: r.taxPercentage,
        usagesCount: r.usagesCount,
        validDate: r.validDate,
        vendor: r.vendor,
        vendorBatchSize: r.vendorBatchSize,
        vendorCode: r.vendorCode,
        vendorUnit: r.vendorUnit,
        orgResourcePriceListId: r.orgResourcePriceListId,
        orgResourcePriceId: r.orgResourcePriceId,
        id: r.id,
        key: r.key,
        estimationResources: Data_Array_NonEmpty.toArray(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(transform)(r.estimationResources))
    };
};
var eqEstimationResourceColumn = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ColCheckbox && y instanceof ColCheckbox) {
                return true;
            };
            if (x instanceof ColName && y instanceof ColName) {
                return true;
            };
            if (x instanceof ColUnit && y instanceof ColUnit) {
                return true;
            };
            if (x instanceof ColCostClassCode && y instanceof ColCostClassCode) {
                return true;
            };
            if (x instanceof ColPricePerUnit && y instanceof ColPricePerUnit) {
                return true;
            };
            if (x instanceof ColPricePerUnitUnit && y instanceof ColPricePerUnitUnit) {
                return true;
            };
            if (x instanceof ColTotalAmountSum && y instanceof ColTotalAmountSum) {
                return true;
            };
            if (x instanceof ColTotalPriceSum && y instanceof ColTotalPriceSum) {
                return true;
            };
            if (x instanceof ColResourceClassificationGroup && y instanceof ColResourceClassificationGroup) {
                return true;
            };
            if (x instanceof ColSortingNumber && y instanceof ColSortingNumber) {
                return true;
            };
            if (x instanceof ColDiscountPercentage && y instanceof ColDiscountPercentage) {
                return true;
            };
            if (x instanceof ColPriceWithDiscount && y instanceof ColPriceWithDiscount) {
                return true;
            };
            if (x instanceof ColCurrencyId && y instanceof ColCurrencyId) {
                return true;
            };
            if (x instanceof ColContract && y instanceof ColContract) {
                return true;
            };
            if (x instanceof ColIndex && y instanceof ColIndex) {
                return true;
            };
            if (x instanceof ColValidDate && y instanceof ColValidDate) {
                return true;
            };
            if (x instanceof ColDiscountGroupCode && y instanceof ColDiscountGroupCode) {
                return true;
            };
            if (x instanceof ColChangeDate && y instanceof ColChangeDate) {
                return true;
            };
            if (x instanceof ColTaxRate && y instanceof ColTaxRate) {
                return true;
            };
            if (x instanceof ColEanCode && y instanceof ColEanCode) {
                return true;
            };
            if (x instanceof ColPLPriceListId && y instanceof ColPLPriceListId) {
                return true;
            };
            if (x instanceof ColInternalCode && y instanceof ColInternalCode) {
                return true;
            };
            if (x instanceof ColVendor && y instanceof ColVendor) {
                return true;
            };
            if (x instanceof ColVendorCode && y instanceof ColVendorCode) {
                return true;
            };
            if (x instanceof ColVendorUnit && y instanceof ColVendorUnit) {
                return true;
            };
            if (x instanceof ColVendorBatchSize && y instanceof ColVendorBatchSize) {
                return true;
            };
            return false;
        };
    }
};
var handleExtraVisibleColumns = function (visibleColumns) {
    var $364 = Data_Array.elem(eqEstimationResourceColumn)(ColPricePerUnitUnit.value)(visibleColumns);
    if ($364) {
        return Data_Semigroup.append(Data_Semigroup.semigroupArray)(visibleColumns)([ ColPricePerUnit.value ]);
    };
    return visibleColumns;
};
var ordEstimationResourceColumn = {
    compare: function (x) {
        return function (y) {
            if (x instanceof ColCheckbox && y instanceof ColCheckbox) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColCheckbox) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColCheckbox) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColName && y instanceof ColName) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColName) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColName) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColUnit && y instanceof ColUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColCostClassCode && y instanceof ColCostClassCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColCostClassCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColCostClassCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPricePerUnit && y instanceof ColPricePerUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPricePerUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPricePerUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPricePerUnitUnit && y instanceof ColPricePerUnitUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPricePerUnitUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPricePerUnitUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColTotalAmountSum && y instanceof ColTotalAmountSum) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColTotalAmountSum) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColTotalAmountSum) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColTotalPriceSum && y instanceof ColTotalPriceSum) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColTotalPriceSum) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColTotalPriceSum) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColResourceClassificationGroup && y instanceof ColResourceClassificationGroup) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColResourceClassificationGroup) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColResourceClassificationGroup) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColSortingNumber && y instanceof ColSortingNumber) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColSortingNumber) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColSortingNumber) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColDiscountPercentage && y instanceof ColDiscountPercentage) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColDiscountPercentage) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColDiscountPercentage) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPriceWithDiscount && y instanceof ColPriceWithDiscount) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPriceWithDiscount) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPriceWithDiscount) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColCurrencyId && y instanceof ColCurrencyId) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColCurrencyId) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColCurrencyId) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColContract && y instanceof ColContract) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColContract) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColContract) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColIndex && y instanceof ColIndex) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColIndex) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColIndex) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColValidDate && y instanceof ColValidDate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColValidDate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColValidDate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColDiscountGroupCode && y instanceof ColDiscountGroupCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColDiscountGroupCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColDiscountGroupCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColChangeDate && y instanceof ColChangeDate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColChangeDate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColChangeDate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColTaxRate && y instanceof ColTaxRate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColTaxRate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColTaxRate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColEanCode && y instanceof ColEanCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColEanCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColEanCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLPriceListId && y instanceof ColPLPriceListId) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLPriceListId) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLPriceListId) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColInternalCode && y instanceof ColInternalCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColInternalCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColInternalCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColVendor && y instanceof ColVendor) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColVendor) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColVendor) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColVendorCode && y instanceof ColVendorCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColVendorCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColVendorCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColVendorUnit && y instanceof ColVendorUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColVendorUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColVendorUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColVendorBatchSize && y instanceof ColVendorBatchSize) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Types.MergedEstimationResource (line 106, column 1 - line 106, column 76): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqEstimationResourceColumn;
    }
};
module.exports = {
    fromMergedEstimationResource: fromMergedEstimationResource,
    ColCheckbox: ColCheckbox,
    ColName: ColName,
    ColUnit: ColUnit,
    ColCostClassCode: ColCostClassCode,
    ColPricePerUnit: ColPricePerUnit,
    ColPricePerUnitUnit: ColPricePerUnitUnit,
    ColTotalAmountSum: ColTotalAmountSum,
    ColTotalPriceSum: ColTotalPriceSum,
    ColResourceClassificationGroup: ColResourceClassificationGroup,
    ColSortingNumber: ColSortingNumber,
    ColDiscountPercentage: ColDiscountPercentage,
    ColPriceWithDiscount: ColPriceWithDiscount,
    ColCurrencyId: ColCurrencyId,
    ColContract: ColContract,
    ColIndex: ColIndex,
    ColValidDate: ColValidDate,
    ColDiscountGroupCode: ColDiscountGroupCode,
    ColChangeDate: ColChangeDate,
    ColTaxRate: ColTaxRate,
    ColEanCode: ColEanCode,
    ColPLPriceListId: ColPLPriceListId,
    ColInternalCode: ColInternalCode,
    ColVendor: ColVendor,
    ColVendorCode: ColVendorCode,
    ColVendorUnit: ColVendorUnit,
    ColVendorBatchSize: ColVendorBatchSize,
    handleExtraVisibleColumns: handleExtraVisibleColumns,
    eqEstimationResourceColumn: eqEstimationResourceColumn,
    ordEstimationResourceColumn: ordEstimationResourceColumn,
    genericEstimationResourceColumn: genericEstimationResourceColumn,
    tofuJSONEstimationResourceColumn: tofuJSONEstimationResourceColumn
};
